import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_SubmitService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String): Observable<Array<PM_Service_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMSubmit?token=" + Token).pipe(
      map(data => {
        return data as Array<PM_Service_Interface>
      })
    )
  }

  GetServiceItem(Token: String,id:number): Observable<Array<PM_Itme_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMSubmit/GetServiceItem?token=" + Token
    + "&id="+id).pipe(
      map(data => {
        return data as Array<PM_Itme_Interface>
      })
    )
  }

  SubmitService(
    submitDate: string,
    submitDsc: string,
    id: number,
    type: number,
    Item:Array<number>,
    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');



    var body = {
      submitDate: submitDate,
      submitDsc: submitDsc,
      item : Item,
      id : id,
      type : type,
      token: Token
    }

    return this.http.post(environment.BaseUrl + "Daro/PMSubmit/SubmitService", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

}
